//libs
import React, { memo, useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';

//components
import ChunkFallback from 'shared/components/ChunkFallback';

function RedirectToHomePage() {
  const [shouldRedirect, setShouldRedirect] = useState(false);
  useEffect(() => {
    let frameId = window.requestAnimationFrame(() => {
      frameId = window.requestAnimationFrame(() => {
        setShouldRedirect(true);
      });
    });

    return () => {
      window.cancelAnimationFrame(frameId);
    };
  }, []);
  if (shouldRedirect) {
    return <Redirect to={'/'} />;
  }
  return <ChunkFallback />;
}

export default memo(RedirectToHomePage);
